import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    global: {
      hello: "Hello",
      welcome: "Welcome",
    },
    page_label: {
      doc_template: "Doc Template",
      doc_create: "Doc Create",
    },
  },
  cn: {
    global: {
      hello: "嗨",
      welcome: "欢迎",
    },
    page_label: {
      doc_template: "文件模板",
      doc_create: "文件建设",
    },
  },
};

export default new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
  silentTranslationWarn: true, // hides missing translation key warnings
  silentFallbackWarn: true, // hides fallback locale warnings
  // missing: (locale, key) => key
});
